<template>
    <div>
        <template v-if="lista.place">
            <ProcesoCompraAbonadosSga v-if="teatro.sga"/>
            <ProcesoCompraAbonadoLfp v-else-if="manager.lfp && url.includes('test=true')"/>
            <ProcesoCompraAbonadoNormal v-else/>
        </template>
        <ProcesoCompraAbonadosSinRecinto v-else/>
    </div>
</template>

<script>
import ProcesoCompraAbonadoNormal from '@/components/frontend/abonos/nuevo/ProcesoCompraAbonadoNormal';
import ProcesoCompraAbonadoLfp from '@/components/frontend/abonos/nuevo/ProcesoCompraAbonadoLfp';
import ProcesoCompraAbonadosSga from '@/components/frontend/abonos/sga/ProcesoCompraAbonadosSga.vue';
import ProcesoCompraAbonadosSinRecinto from '@/components/frontend/abonos/nuevo/ProcesoCompraAbonadosSinRecinto.vue';

export default {
    computed: {
        manager() {
            return this.$store.getters.getFooter;
        },
        url() {
            return window.location.href;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        },
        lista() {
            return this.$store.getters.getListaAbonados;
        }
    },
    components: {
        ProcesoCompraAbonadoNormal, ProcesoCompraAbonadoLfp, ProcesoCompraAbonadosSga, ProcesoCompraAbonadosSinRecinto
    }
}
</script>